import { getPinyins, getMaps } from 'utils/queries/pinyin';

export const pinyinEndpoints = (build) => ({
  getPinyins: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getPinyins,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.getPinyins,
  }),
  getMaps: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getMaps,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.getMaps,
  }),
});
